import * as yup from "yup";

export const auditorSchema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  emailAddress: yup
    .string()
    .email("Invalid email")
    .required("Email is required"),
  secondEmailAddress: yup.string().email("Invalid email"),

  companyAffiliation: yup.string().required(),
  officePhone: yup
    .string()
    .matches(/^[0-9]+$/, "Phone number must contain only numbers"),
  mobilePhone: yup
    .string()
    .matches(/^[0-9]+$/, "Phone number must contain only numbers"),
  country: yup
    .object({
      name: yup.string().required("Country is required"),
    })
    .required("Country is required"),
  city: yup.string().required(),
  state: yup.string().required(),
  training: yup.string().required(),
  dateOfCompletion: yup
    .object({
      startDate: yup
        .date()
        .required("Start date is required")
        .test(
          "is-valid-date",
          "Start date must be a valid date",
          (value) => !isNaN(new Date(value).getTime())
        ),
    })
    .required("Draft date is required"),
  cv: yup.mixed().required("CV is required"),
});
